import { createUniqueId, splitProps } from "solid-js";
import { formControlProps, InputFormControl } from "./formControl";
import FormControlErrors, { errorId } from "./FormControlErrors";
import FormLabel from "./FormLabel";
import { inputTypeGuard } from "./input";

export const stringInputTypes = [
  "text",
  "hidden",
  "password",
  "email",
  "url",
  "tel",
  "color",
  "time", // TODO: time might require a separate input component
  "week",
  "month",
] as const;
export const isStringInputType = inputTypeGuard(stringInputTypes);
export type StringInputType = typeof stringInputTypes[number];
const StringFormControl: InputFormControl<
  string | undefined,
  StringInputType
> = (props) => {
  const [local, inputProps] = splitProps(props, formControlProps);
  const id = local.id ?? createUniqueId();
  const invalid = () => (local.errors || []).length > 0;
  return (
    <>
      <FormLabel for={id}>{local.label}</FormLabel>
      <input
        type="text"
        id={id}
        aria-error-message={invalid() && errorId(id, 0)}
        aria-invalid={invalid()}
        {...inputProps}
        classList={{
          ...local.classList,
          ["ps-2"]:true,
          ["form-control"]: true,
          ["is-invalid"]: invalid(),
        }}
      />
      <FormControlErrors for={id} errors={local.errors} />
    </>
  );
};
export default StringFormControl;
